import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'semantic-ui-react';
import styled from 'styled-components';

import { CsvUploadButton } from './CsvUploadButton';

type Props = {
  children?: never;
  isPreview: boolean;
  isUploading: boolean;
  onDownloadCsvClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onUploadCsvClick: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Section: React.FC<Props> = ({
  isPreview,
  isUploading,
  onDownloadCsvClick,
  onUploadCsvClick,
}) => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <H1>{t('pages.user.title')}</H1>
      <Span>{t('text.user.index.description')}</Span>
      <Box>
        <CsvUploadButton
          isUploading={isUploading}
          onChange={onUploadCsvClick}
        />
        <Div>
          <Note>{t('text.user.index.noteAboutUser')}</Note>
          <Note>{t('text.user.index.noteAboutFormat')}</Note>
          <Note>{t('text.user.index.noteAboutNameId')}</Note>
        </Div>
        {!isPreview && (
          <A onClick={onDownloadCsvClick}>
            <Icon name="download" />
            {t('text.user.index.csvDownload')}
          </A>
        )}
      </Box>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  margin-bottom: 24px;
`;

const H1 = styled.h1`
  font-size: 24px;
  font-weight: 600;
`;

const Span = styled.span`
  margin-top: 24px;
  font-size: 14px;
  color: #999999;
`;

const Box = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
`;

const Div = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  margin-left: 16px;
`;

const Note = styled.span`
  font-size: 12px;
  color: #9f3a38;

  &:before {
    content: '※';
    margin-right: 2px;
  }
`;

const A = styled.a`
  font-size: 14px;
  cursor: pointer;
`;
